module.exports = __webpack_public_path__ + "4cf40dc1be092db7ed8af28c2149cc73.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/nl/apple_store.svg
// module id = 846
// module chunks = 0